import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';

import { ModalId } from 'src/constants/modals';
import { useInboxItemParamId } from 'src/hooks/inboxItem';
import { useModal } from 'src/hooks/shared';
import { useTestVerificationRequestsRoute } from 'src/hooks/testVerificationRequests';
import { useVerificationRequestProcessing } from 'src/hooks/verificationRequest';
import { InboxLayout, LayoutHeaderAction } from 'src/layouts/InboxLayout';

import { InboxItemContentPlatformStaff } from '../inboxItem/InboxItemContent';

export const InboxCVStaff: React.FC = () => {
  const { openModal } = useModal();

  const inboxItemId = useInboxItemParamId();

  const { isSubmitting } = useVerificationRequestProcessing();

  const { isTestRequestsRoute } = useTestVerificationRequestsRoute();

  const topAction = React.useMemo((): LayoutHeaderAction => {
    if (isTestRequestsRoute) {
      return {
        actionName: 'Create Test Request',
        icon: <AddIcon />,
        disabled: isSubmitting,
        loading: isSubmitting,
        onAction: () => openModal(ModalId.TestVerificationRequestCreateModal),
      };
    }

    return {
      actionName: 'Create Request',
      icon: <AddIcon />,
      disabled: isSubmitting,
      loading: isSubmitting,
      onAction: () => openModal(ModalId.VerificationRequestCreateByCVStaff),
    };
  }, [isTestRequestsRoute, isSubmitting, openModal]);

  return (
    <InboxLayout topAction={topAction}>
      <InboxItemContentPlatformStaff inboxItemId={inboxItemId} />
    </InboxLayout>
  );
};
